import React from "react";
import styles from "./SellingPoints.module.scss";
import CircleCheckGreen from "./CircleCheckGreen.svg";
import CircleCrossRed from "./CircleCrossRed.svg";

export interface ISellingPoints {
  title: string;
  points: string[];
  type: "featured" | "horizontal" | "checkbox" | "crosslist";
}

const resolveIcon = (type: "checkbox" | "crosslist") => {
  switch (type) {
    case "checkbox":
      return <img alt="" title={"Green Check Icon"} className={styles.checkListIcon} src={CircleCheckGreen} />;
    case "crosslist":
      return <img alt="" title={"Red Cross Icon"} className={styles.checkListIcon} src={CircleCrossRed} />;
  }
};

const SellingPoints: ReactFCWithNoJs<ISellingPoints> = (props) => {
  const { title, points, type } = props;
  const key = (index: number) => `sellingPoint-${title}-${index}`;
  switch (type) {
    case "featured":
      return (
        <>
          {title && <h2 className={styles.featuredListHeader}>{title}</h2>}
          <ul className={styles.featuredList}>
            {points.map((sellingPoint, index) => (
              <li key={key(index)} className={styles.featuredListItems}>
                <span className={styles.featuredListItemsLine}>{sellingPoint}</span>
              </li>
            ))}
          </ul>
        </>
      );
    case "horizontal":
      return (
        <>
          {title && <h2 className={styles.horizontalListHeader}>{title}</h2>}
          <ul className={styles.horizontalList}>
            {points.map((sellingPoint, index) => (
              <li key={key(index)} className={styles.horizontalListItems}>
                <span className={styles.horizontalListItemsLine}>{sellingPoint}</span>
              </li>
            ))}
          </ul>
        </>
      );
    case "checkbox":
    case "crosslist":
      return (
        <div className={styles.checklistWrapper}>
          {title && <p className={styles.checklistHeader}>{title}</p>}
          <ul className={styles.checklistContainer}>
            {points.map((sellingPoint, index) => (
              <li key={key(index)} className={styles.checklistItem}>
                {resolveIcon(type)}
                <span>{sellingPoint}</span>
              </li>
            ))}
          </ul>
        </div>
      );
  }
};
SellingPoints.noJsRequired = true;
export default SellingPoints;
